export const optOutUrl = 'companyoptout';